import * as Immutable from 'immutable';
import * as doorFieldName from './constants/DoorFields';
import * as mouldingFieldName from './constants/MouldingFields';

export function modalId(fieldName) {
  return fieldName + '-options';
}

export function rawHTML(html) {
  return { __html: html};
}

export function fetchJSON(url) {
  if (localStorageAvailable()) {
    const cachedPromise = sessionStorage.getItem(url);
    
    if (cachedPromise) {
      return Promise.resolve(JSON.parse(cachedPromise));
    }
    
    return getURL(url).then((data) => {
      sessionStorage.setItem(url, data);
      return JSON.parse(data);
    });
  }
  
  return getJSON(url);
}

export function getJSON(url) {
  return getURL(url).then(JSON.parse);
}

export function buttonText(productType) {
  switch (productType) {
    case 'door':
      return 'Door';
    case 'moulding':
      return 'Moulding';
    case 'wood-beam':
      return 'Wood Beam';
    case 'flooring':
      return 'Flooring';
    default:
      return productType;
  }
}

export function getURL(url) {
// Return a new promise.
  return new Promise(function(resolve, reject) {
    // Do the usual XHR stuff
    var req = new XMLHttpRequest();
    req.open('GET', url);
    req.withCredentials = true;

    req.onload = function() {
      // This is called even on 404 etc
      // so check the status
      if (req.status == 200) {
        // Resolve the promise with the response text
        resolve(req.response);
      }
      else {
        // Otherwise reject with the status text
        // which will hopefully be a meaningful error
        reject(Error(req.statusText));
      }
    };

    // Handle network errors
    req.onerror = function() {
      reject(Error("Network Error"));
    };

    // Make the request
    req.send();
  });
}

export function structureData(productObj, fieldObj) {
  const product = Immutable.Map(productObj.data);
  const fields = fieldObj.data.reduce(function(map, field) {
    return map.set(field.name, Immutable.Map(field));
  }, Immutable.Map());
  
  return Immutable.Map({
    product: product,
    fields: fields,
    fieldOrder: groupFields(fieldObj.data)
  });
}

export function groupFields(fields) {
  return fields.reduce(function(map, field) {
    return map.updateIn([field.group], Immutable.List(), list => list.push(field.name));
  }, Immutable.OrderedMap());
}

export function fetchStoredMouldingValues(state) {
  if (localStorageAvailable) {
    const product = state.get('product');
    const mouldingName = product.get('name');
    const newState = state
            .setIn(['fields', mouldingFieldName.THICKNESS_A, 'value'], product.get('thicknessA'))
            .setIn(['fields', mouldingFieldName.WIDTH_A, 'value'], product.get('widthA'))
            .setIn(['fields', mouldingFieldName.LENGTH, 'value'], product.get('length'))
            .setIn(['fields', mouldingFieldName.THICKNESS_B, 'value'], product.get('thicknessB'))
            .setIn(['fields', mouldingFieldName.WIDTH_B, 'value'], product.get('widthB'));

    localStorage.currentMoulding = mouldingName;
    localStorage.currentMouldingId = product.get('id');

    const mouldingsString = localStorage.mouldings;

    if (!mouldingsString) {
      return newState;
    }

    const mouldings = JSON.parse(mouldingsString);
    const moulding = mouldings[mouldingName];

    if (!moulding) {
      return newState;
    }

    const newMappedState = newState.set('fields', newState.get('fields').map((field, name) => {
      const storedValue = moulding[name];
      if (storedValue) {
        const updatedField = field.set('value', storedValue);
        const storedCustomValue = moulding[name+'_custom'];

        if (storedCustomValue) {
          return updatedField.set('custom_value', storedCustomValue);
        }

        return updatedField;
      } else {
        return field;
      }
    }));
    
    return newMappedState;
  }

  return state;
}

export function fetchStoredWoodBeamValues(state) {
  if (localStorageAvailable) {
    const product = state.get('product');
    const woodBeamName = product.get('name');

    localStorage.currentWoodBeam = woodBeamName;
    localStorage.currentWoodBeamId = product.get('id');

    const woodBeamsString = localStorage['wood-beams'];

    if (!woodBeamsString) {
      return state;
    }

    const woodBeams = JSON.parse(woodBeamsString);
    const woodBeam = woodBeams[woodBeamName];

    if (!woodBeam) {
      return state;
    }

    const newMappedState = state.set('fields', state.get('fields').map((field, name) => {
      const storedValue = woodBeam[name];
      if (storedValue) {
        const updatedField = field.set('value', storedValue);
        const storedCustomValue = woodBeam[name+'_custom'];

        if (storedCustomValue) {
          return updatedField.set('custom_value', storedCustomValue);
        }

        return updatedField;
      } else {
        return field;
      }
    }));
    
    return newMappedState;
  }

  return state;
}

export function fetchStoredValues(state) {
  if (localStorageAvailable) {
    let doorName = state.getIn(['product', 'name']),
        doorType = localStorage.doorType,
        singleDouble = document.location.href.indexOf('?double') > 0 ? 'Double Door' : 'Single Door',
        interiorExteriorDefault = (function(doorType) {
          switch(doorType) {
            case 'wood-fire-doors':
              return 'Fire Door';
            case 'wood-interior-doors':
              return 'Interior Door';
            case 'wood-exterior-doors':
              return 'Exterior Door';
          }
          return '';
        })(doorType),
        newState = state
          .setIn(['product', 'doorType'], doorType)
          .setIn(['fields', doorFieldName.SINGLE_DOUBLE, 'value'], singleDouble)
          .setIn(['fields', doorFieldName.INTERIOR_EXTERIOR, 'value'], interiorExteriorDefault);
          
    localStorage.currentDoor = doorName;
    localStorage.currentDoorId = newState.getIn(['product', 'id']);
    
    let doors = localStorage.doors;
    if (!doors) {
      return newState;
    }
    doors = JSON.parse(doors);
    
    let door = doors[doorName];
    if (!door) {
      return newState;
    }

    let newMappedState = newState.set('fields', newState.get('fields').map((field, name) => {
      let storedValue = door[name];
      if (storedValue) {
        let updatedField = field.set('value', storedValue);
        let storedCustomValue = door[name+'_custom'];
        if (storedCustomValue) {
          return updatedField.set('custom_value', storedCustomValue);
        }
        return updatedField;
      } else {
        return field;
      }
    }));
    
    if (interiorExteriorDefault.length > 0) {
      return newMappedState.setIn(['fields', doorFieldName.INTERIOR_EXTERIOR, 'value'], interiorExteriorDefault);
    } else {
      return newMappedState;
    }
  } else {
    return state;
  }
}

export function localStorageAvailable() {
  return typeof(Storage) !== "undefined";
}
